import styled from "styled-components";

import { RecommendedSnacksListStyledProps as Props } from "./RecommendedSnacksList.types";

const RecommendedSnacksListStyled = styled.div<Props>`
  .RecommendedSnacksList {
    &__title {
      color: var(--palette-light-blue-s10-l60);
      text-align: start;
      font-size: 1.6rem;
      font-weight: 700;
      padding: 1.6rem 0.8rem;
    }
  }
`;

export default RecommendedSnacksListStyled;
